import React from 'react';
import { PlayListItem } from './PlayListItem.jsx';

export const PlayList = ({playlist, playlistIsOpen, onTrackClick, playlistPosition, audioPlayerIsLoading}) => {
    return (
        <div className="playlist">
            {playlistIsOpen && 
            <>
                { playlist.length > 0 && (playlistPosition !== -1 ||  audioPlayerIsLoading ) &&
                <>
                    <div className="playlist-header">Now Playing { audioPlayerIsLoading &&
                            <span className="loading"></span>
                        }</div>
                    <div className="playlist-list">
                        <PlayListItem audioPlayerIsLoading={audioPlayerIsLoading} CurrentTrack={true} key={'nowplaying'} track={playlist[playlistPosition]} onTrackClick={onTrackClick}></PlayListItem>
                    </div>
                </>
                }
                { playlistPosition < playlist.length - 1 && 
                    <div className="playlist-header">Next</div>
                }
                <div className="playlist-list next">
                { playlist.map((item, index) => {
                    if(index > playlistPosition) {
                        return(
                        <PlayListItem audioPlayerIsLoading={false} isCurrentTrack={playlistPosition == index ? true : false} key={index} track={item} onTrackClick={onTrackClick}></PlayListItem>
                        )
                    }
                    }

                )
                }
                {playlist.length == 0 &&
                    <div className="empty">No track selected</div>
                }
                </div>
            </>
            }
        </div>
    );
}